import type { HTMLAttributes, ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

export interface RootProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode
  withError?: boolean
  count?: number
  limit?: number
}

export function Root({
  className,
  withError,
  count,
  limit,
  children,
  ...rest
}: RootProps) {
  return (
    <div
      {...rest}
      className={twMerge(
        'relative flex h-10 w-full items-center gap-2 rounded-lg border border-zinc-400 bg-white px-3 py-1 shadow-xs outline-hidden 2xl:h-12 2xl:py-2',
        'focus-within:border-bios-300 focus-within:ring-4 focus-within:ring-bios-50',
        'has-disabled:cursor-not-allowed has-disabled:bg-monochromatic-200 has-disabled:text-monochromatic-500',
        'has-[:-internal-autofill-selected]:bg-monochromatic-100',
        withError &&
          'border-red-500 focus-within:border-red-500 focus-within:ring-4 focus-within:ring-red-100',
        className,
      )}
    >
      {children}
      {limit && (
        <p className="absolute bottom-0 right-2 select-none text-sm">
          {count}/{limit}
        </p>
      )}
    </div>
  )
}
